import { Button, Stack, Text } from "basis";
import { ActionType, ScreenProps } from "./types";

export const ImportantInformation = ({ dispatch }: ScreenProps) => (
  <Stack gap="8">
    <Text as="h3" textStyle="heading4">
      Important information when applying for a credit limit increase.
    </Text>
    <div>
      <Text>
        <strong>When will my new credit limit be updated?</strong>
      </Text>
      <Text>
        If approved, your new credit limit will be updated immediately.
      </Text>
    </div>
    <div>
      <Text>
        <strong>What details will I need?</strong>
      </Text>
      <Text>
        To be approved, please have your income details, and any other credit
        card limit and loan balances handy.
        <br />
        Based on your application, you may be asked to provide proof of income.
        It may take up to 2 business days to provide a final decision.
      </Text>
    </div>
    <div>
      <Text>
        <strong>Please note:</strong>
      </Text>
      <Text>
        After submitting this application, regardless of the outcome of the
        application or if you choose to cancel it, you will not be able to
        request for another credit limit increase within 30 days.
      </Text>
    </div>
    <div>
      <Text>
        <strong>What happens after 30 days?</strong>
      </Text>
      <Text>
        You may be eligible to request for a new credit limit increase 30 days
        after submitting your last application by returning to Manage My Credit
        Limit.
      </Text>
    </div>
    <Button
      width="192"
      onClick={() => {
        dispatch({
          type: ActionType.IMPORTANT_INFORMATION_BACK_CLICKED,
        });
      }}
    >
      Back
    </Button>
  </Stack>
);
